module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-4a0faced.png";